<template>
  <router-view />
</template>

<script setup>
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useStore } from "vuex";
const store = useStore();
// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCDMMWBZtD-N1zSEuzbUYzsllSFVWk6H14",
  authDomain: "alliance-crm-fe259.firebaseapp.com",
  projectId: "alliance-crm-fe259",
  storageBucket: "alliance-crm-fe259.appspot.com",
  messagingSenderId: "83440943839",
  appId: "1:83440943839:web:e1c825f876ced21f885f6a",
};

try {
  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });

    // Handle incoming messages
    onMessage(messaging, (payload) => {
      console.info("Message received. ", payload);
      store.dispatch("getNotificationCount");
    });

    // Get and store token
    getToken(messaging, { vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY })
      .then((currentToken) => {
        if (currentToken) {
          localStorage.setItem("message_token", currentToken);
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.error("An error occurred while retrieving token. ", err);
      });
  } else {
    console.warn("Service workers are not supported in this browser.");
  }
} catch (error) {
  console.error("Firebase initialization error:", error);
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
